export const stickyCarouselState = {
  state: {
    playerType: null,
    autoStart: false,
    isClosed: false,
    isScrolled: false,
    elementInCarouselHeight: null,
    hideStickyTimeOut: null,
  },
  setState(key, value) {
    if (Object.prototype.hasOwnProperty.call(this.state, key)) {
      this.state[key] = value;
    }
  },
  getState(key) {
    if (Object.prototype.hasOwnProperty.call(this.state, key)) {
      return this.state[key];
    }
    return undefined;
  },
};
